export enum WalletType {
    APPLE_PAY = 'applepay',
    GOOGLE_PAY = 'googlepay',
}
